import type { IconData } from '@stacksjs/iconify-core'

export const basicUiRemove: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M0 5v6h16V5z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default basicUiRemove
